import React, { useEffect, useState } from 'react';
import { Container } from 'reactstrap';

import ExploreProductsTabs from "./ExploreProductsTabs";
import ExploreProductsMobile from "./ExploreProductsMobile";
function ExploreProducts(props) {
	const [mobile,setMobile] = useState(false)
    
    const checkAnd = async () => {
        if( /Android|webOS|iPhone|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) ) {
            setMobile({mobile:true})
        }
    }
    useEffect(()=>{
        checkAnd();
    },[])

	return (
		<div className="products-section pb-4">
			<Container>
				<p className={!mobile ? "header-detased text-left":"header-detased"}>Explore More</p>
				<div className={!mobile ? "pc text-left":"pc"}>
					<ExploreProductsTabs />
				</div>
				<div className="mobile">
					<ExploreProductsMobile />
				</div>
			</Container>
		</div>
	);
}

export default ExploreProducts;
